import React, { FunctionComponent } from "react";
import { ILink } from "./interfaces";
import { Link } from "react-router-dom";

interface IDesktopNavbarProps {
  links: ILink[];
}

const DesktopNavbar: FunctionComponent<IDesktopNavbarProps> = ({ links }) => {
  return (
    <nav className="navbar flex items-center justify-between lg:justify-center flex-wrap fixed w-full bg-black lg:pt-4">
      <div className="w-full flex flex-col lg:flex-row lg:justify-center">
        <div className="flex w-full lg:w-auto justify-between">
          <div className="flex items-center flex-shrink-0 text-white mr-6 p-6">
            <Link to="/">
              <img
                src="/images/stempeers_logo-02.png"
                width={45}
                height={45}
                alt=""
              />
            </Link>
          </div>
          <div className="flex lg:hidden items-center">
            <button className="flex-items-center px-3 py-2 text-white hover:text-white hover:border-white">
              <svg
                className="fill-current h-5 w-5"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <title>Menu</title>
                <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
              </svg>
            </button>
          </div>
        </div>
        <ul className="flex">
          {links.map((link, index) => (
            <li
              key={index}
              className="navbar__link relative flex items-center px-3 text-xs font-bold"
            >
              <Link to={link.href} className="text-white hover:text-gray-700">
                {link.text}
                {link.sublinks && <i className="icon-angle-down fa-sm ml-2" />}
              </Link>
              {link.sublinks && (
                <ul className="navbar__sublinks absolute p-6 left-0 top-100 bg-gray-900 hidden">
                  {link.sublinks.map((sublink, sIndex) => (
                    <li key={sIndex} className="py-1">
                      {sublink.external ? (
                        <a
                          href={sublink.href}
                          target="_blank"
                          className="text-white text-sm font-light font-poppins hover:text-gray-700"
                        >
                          {sublink.text}
                        </a>
                      ) : (
                        <Link
                          to={sublink.href}
                          className="text-white text-sm font-light font-poppins hover:text-gray-700"
                        >
                          {sublink.text}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
        <div className="hidden lg:flex text-white py-6 pl-8 items-center">
          <a
            className="hover:text-gray-700"
            href="https://www.facebook.com/STEMPeer15/"
          >
            <i className="icon-facebook2 mr-3" />
          </a>
          <a
            className="hover:text-gray-700"
            href="https://twitter.com/Stempeer15?lang=en"
          >
            <i className="icon-twitter-square mr-3" />
          </a>
          <a
            className="hover:text-gray-700"
            href="https://www.linkedin.com/company/phdcareersupportgroup/"
          >
            <i className="icon-linkedin" />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default DesktopNavbar;
